(function () {
  'use strict';

  function getEndOfDayMs() {
    var end = new Date();
    end.setHours(23, 59, 59, 999);
    return end.getTime();
  }

  function formatCountdown(ms) {
    if (ms <= 0) return '00:00:00';
    var totalSeconds = Math.floor(ms / 1000);
    var h = Math.floor(totalSeconds / 3600);
    var m = Math.floor((totalSeconds % 3600) / 60);
    var s = totalSeconds % 60;
    return (
      String(h).padStart(2, '0') +
      ':' +
      String(m).padStart(2, '0') +
      ':' +
      String(s).padStart(2, '0')
    );
  }

  function initBanner(banner) {
    var timeEl = banner.querySelector('[data-sc-flow-gift-time]');
    if (!timeEl) return;

    function tick() {
      var remaining = getEndOfDayMs() - Date.now();
      timeEl.textContent = formatCountdown(remaining);
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function boot() {
    document.querySelectorAll('[data-sc-flow-gift-countdown]').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
